import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultFilmReleaseDateDisplayText = {
    label: 'Release date',
    format: '${date|d|D MMMM YYYY}'
};
export const filmReleaseDateDisplayTextValidatorSchema = {
    label: Validator.optional(nonEmptyStringValidator),
    format: nonEmptyStringValidator
};
export const filmReleaseDateDisplayTextValidator = Validator.object(filmReleaseDateDisplayTextValidatorSchema);
